import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ClassValidatorFormControl } from 'ngx-reactive-form-class-validator';

export function getErrors(control: ClassValidatorFormControl) {
  if (control && control.errors && control.touched) {
    const isNotEmptyString = 'isNotEmpty';
    const entries = Object.entries(control.errors);
    const hasIsNotEmptyError = entries
      .map((s) => s[0])
      .includes(isNotEmptyString);
    const primaryErrorIndex =
      entries.length > 0 && hasIsNotEmptyError
        ? entries.findIndex((s) => s[0] === isNotEmptyString)
        : 0;
    return entries[primaryErrorIndex][1];
  }
  return '';
}

// Custom ArrayNotEmpty Validator
export function arrayNotEmptyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (Array.isArray(value) && value.length === 0) {
      return { arrayNotEmpty: true }; // Error key with true means it's invalid
    }
    return null; // Return null if validation passes
  };
}
